import * as d3 from 'd3'

export default {
  methods: {
    draw_SkylineCharts() {

      let sky = this.skyline
      this.canvasSkyline = this.svg
      .append('g')
      .attr('id', 'SKYLINE_CANVAS')
      .attr('transform', `translate(${this.timeline.x}, 0)`)
      .attr('font-family', 'roboto')

      this.canvasFront = this.svg
      .append('g')
      .attr('id', 'SKYLINE_2ndLayer')
      .attr('transform', `translate(${this.timeline.x}, 0)`)
      .attr('font-family', 'roboto')      

      this.timeline.week.forEach((w, i) => {

        let verY = this.timeline.y - sky.height - (sky.gap/2)
        let periodData = null

        periodData = this.skyline.data.filter(f => f.cDate == w.eDate)

        periodData.forEach((d, i) => {
          let x = this.timeline.scale(d.sDate) + sky.gap
          let y = verY
          let width_ = this.timeline.scale(d.cDate) - this.timeline.scale(d.sDate) - sky.gap
          let Boxes = this.canvasSkyline
          .append('g')
          .attr('id', `BOX_${d.SYS}_${d[this.codes.skyline]}`)
          .attr('transform', `translate(${x},${y})`)
          // .attr('cursor', d.opacity < 0.5 && d.opacity != undefined ? 'default' : 'pointer')
          .attr('cursor', 'pointer')
          .call(this.call_Skyline, d, x, y, width_)

          Boxes // Background for mouse-over
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', width_).attr('height', sky.height).attr('fill', '#fff').attr('stroke-width', 0)
          
          if(d.A_STATUS == 'TURNOVER') {
          Boxes
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', width_).attr('height', sky.height).attr('fill', d.bColor).attr('fill-opacity', d.opacity)
          } else {
          Boxes
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', width_ * (d[this.codes.prog]/100)).attr('height', sky.height).attr('fill', d.bColor).attr('fill-opacity', d.opacity)
          }

          // Border only
          Boxes 
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', width_).attr('height', sky.height)
          .attr('fill', 'none').attr('stroke', d.stroke).attr('stroke-width', d.sWidth)
          
          Boxes
          .append('text')
          .attr('x', width_/2).attr('y', sky.height/2 + (d.tSize/2-1.5))
          .attr('font-size', d.tSize).attr('fill', sky.tColor)
          .attr('text-anchor', 'middle').style('pointer-events', 'none')
          .text(d[this.codes.skyline])

          verY = verY - sky.height - (sky.gap)
          
          // Draw the number of box per Month
          if(i == periodData.length-1) {
            this.canvasSkyline
            .append('text')
            .attr('class', 'BLOCK_COUNT')
            .attr('transform', `translate(${x + (width_/2)}, ${verY + sky.height - 2})`)
            .style('font-size', 10).style('fill', '#757575').attr('visibility', 'visible')
            .attr('text-anchor', 'middle')
            .text(periodData.length)
          }
        })
      })
      this.draw_exception()
    },

  }
}
